// extracted by mini-css-extract-plugin
module.exports = {"spinner":"queryStatusHandler_spinner__oyOvi","spin":"queryStatusHandler_spin__J2yxZ"};